export const MAPBOX_KEY =
    "pk.eyJ1IjoiamFzc21pdGg4NyIsImEiOiJjanllMWE0Y2owc2k3M2RvY3o3MXlxbDZxIn0.EQJsvDixbUz2naDzTIfE6Q";

export const iconImageStorageFolder = "icon-images";
export const orgIconImageStorageFolder = "org_icons";
